import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';

export const getClubExpenses = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/club-expenses', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const fetchClubExpense = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/club-expenses/${id}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const createClubExpense = async (data, callback) => {
    try {
        const response = await risapi.post('/api/club-expenses', data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const updateClubExpense = async (data, callback) => {
    try {
        const response = await risapi.put(`/api/club-expenses/${data.id}`, data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const destroyClubExpense = async (expense, callback) => {
    try {
        const response = await risapi.delete(`/api/club-expenses/${expense.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ success: true });
        }
    } catch (error) {
        callback(error);
    }
};

/**
 * Fetches the data required for a club expense statement.
 * @param {number} expenseId - The ID of the club expense.
 * @param {function} callback - The function to call with the response.
 */
export const getClubExpenseStatement = async (expenseId, callback) => {
    try {
        const response = await risapi.get(`/api/club-expenses/${expenseId}/statement`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};
